export enum EmailTrackingEntityType {
    STATIC_LIST = "static list sites",
    CRM_STATIC_LIST = "crm static list sites",
    SAVED_SEARCHES = "saved search",
}
